var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.375 8.5H6.80017C5.82008 8.5 5.32967 8.5 4.95532 8.69074C4.62604 8.85852 4.35852 9.12604 4.19074 9.45532C4 9.82967 4 10.3201 4 11.3002V16.2002C4 17.1803 4 17.6701 4.19074 18.0444C4.35852 18.3737 4.62604 18.6417 4.95532 18.8094C5.3293 19 5.81912 19 6.7973 19H16.9527C17.9309 19 18.42 19 18.794 18.8094C19.1233 18.6417 19.3917 18.3737 19.5594 18.0444C19.75 17.6704 19.75 17.1813 19.75 16.2031V11.2973C19.75 10.3191 19.75 9.8293 19.5594 9.45532C19.3917 9.12604 19.1233 8.85852 18.794 8.69074C18.4196 8.5 17.9303 8.5 16.9502 8.5H15.375M8.375 8.5H15.375M8.375 8.5C8.375 6.567 9.942 5 11.875 5C13.808 5 15.375 6.567 15.375 8.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcaseIcon);
export default __webpack_public_path__ + "static/media/briefcase-icon.abd48aeaf491642d4a264224bc4198bc.svg";
export { ForwardRef as ReactComponent };